import { clone } from "lodash";
import { getSubSubConfigsFromItem } from "../utils.js";
import {
  TRIGGER_FIELDS,
  FIELD_KEYS,
  OPERATORS_LIST,
  DEFAULT_CONFIG_MODEL,
  DEFAULT_CONFIG_OPTIONS,
  PAYLOAD_TO_COMPONENT_TYPES_MAP,
  DEFAULT_COMPONENTS_CONFIG,
  DEFAULT_OPERATOR_MODEL,
  DEFAULT_DELAY_MODEL,
} from "../constants.js";

export default {
  computed: {
    headerControlsProps() {
      return [{
        icon: "add",
        disabled: this.conditions.blocks.length > 1 || this.isViewMode || this.isLoading,
      }, {
        icon: "remove",
        disabled: this.isViewMode || this.isLoading,
      }]
    },
    headerControlsEvents() {
      return [
        { click: () => this.addBlock(TRIGGER_FIELDS.Conditions) },
        { click: () => this.removeBlock(TRIGGER_FIELDS.Conditions) }
      ];
    },
  },

  methods: {
    addItem(field, blockIndex) {
      const isConditionsField = this.checkIsConditionsField(field);
      const isActionsField = this.checkIsActionsField(field);
      const model = isConditionsField ? this[field].blocks[blockIndex].model : this[field].model;
      const options = isConditionsField ? this[field].blocks[blockIndex].options : this[field].options;
      const type = isConditionsField ? this[field].blocks[0].options[0].type : this[field].options[0].type;
      const components = isConditionsField
        ? this[field].blocks[blockIndex].components
        : this[field].components;
      const delay = isActionsField ? this[field].delay : null;

      this.$set(model, model.length, clone(DEFAULT_CONFIG_MODEL));
      this.$set(options, options.length, { type,  ...DEFAULT_CONFIG_OPTIONS });

      this[field].itemsCount += 1;
      this.$set(model[model.length - 1], "_itemId", this[field].itemsCount);

      this.$set(components, components.length, clone(DEFAULT_COMPONENTS_CONFIG));

      if (isActionsField) {
        this.$set(delay, delay.length, clone(DEFAULT_DELAY_MODEL));
      }
    },

    removeItem(field, index, blockIndex) {
      if (this.checkIsConditionsField(field)) {
        this.$delete(this[field].blocks[blockIndex].model, index);
        this.$delete(this[field].blocks[blockIndex].options, index);
        this.$delete(this[field].blocks[blockIndex].components, index);
        return;
      }

      if (this.checkIsActionsField(field)) {
        this.$delete(this[field].components, index);
      }

      this.$delete(this[field].model, index);
      this.$delete(this[field].options, index);
    },

    addBlock(field) {
      this[field].blocksCount += 1;
      this.$set(this[field].blocks, this[field].blocks.length, {
        model: [],
        options: [],
        components: [],
        operator: clone(DEFAULT_OPERATOR_MODEL),
        operators: clone(OPERATORS_LIST),
        _blockId: this[field].blocksCount,
      });

      this.addItem(field, this[field].blocks.length - 1);
    },

    removeBlock(field) {
      this.$delete(this[field].blocks, this[field].blocks.length - 1);
      this.isFullLogicShown = false;
    },

    selectOperator(event, field, blockIndex) {
      if (isNaN(blockIndex)) {
        this[field].operator = {
          ...this[field].operator,
          [event.key]: event.value.id,
        };
        return;
      }
      this[field].blocks[blockIndex].operator = {
        ...this[field].blocks[blockIndex].operator,
        [event.key]: event.value.id,
      }
    },

    setActionDelay(event, index) {
      this.actions.delay[index][event.key] = event.value;
    },

    getItemCount(field, index, blockIndex) {
      return blockIndex > 0
        ? this[field].blocks[blockIndex - 1].model.length + index + 1
        : index + 1;
    },

    resetChildModel(field, currentKey, index, blockIndex) {
      const { Type, Configuration, SubConfiguration, SubSubConfiguration } = FIELD_KEYS;
      const isIndex = !isNaN(index);
      const isBlockIndex = !isNaN(blockIndex);
      const source = isBlockIndex ? this[field].blocks[blockIndex].model[index] : this[field].model[index]
      const count = getSubSubConfigsFromItem(isIndex ? source : this[field].model).length;

      switch (currentKey) {
        case Type:
          if (isBlockIndex) {
            // TODO add this for other cases
            if (this[field].blocks[blockIndex].model[index][Configuration].range) {
              this[field].blocks[blockIndex].model[index][Configuration].range = [0, 0];
              this[field].blocks[blockIndex].model[index][Configuration].condition_id = "";
            } else {
            this[field].blocks[blockIndex].model[index][Configuration] = "";
            }
            this[field].blocks[blockIndex].model[index][SubConfiguration] = "";
            this[field].blocks[blockIndex].options[index][SubConfiguration] = [];
          } else if (isIndex && !isBlockIndex) {
            this[field].model[index][Configuration] = "";
            this[field].model[index][SubConfiguration] = "";
            this[field].options[index][SubConfiguration] = [];
          } else {
            this[field].model[Configuration] = "";
            this[field].model[SubConfiguration] = "";
            this[field].options[SubConfiguration] = [];
          }

          this.resetSubSubConfiguration(field, "model", index, count, 0, blockIndex);
          this.resetSubSubConfiguration(field, "options", index, count, 0, blockIndex);
          break;

        case Configuration:
          if (isBlockIndex) {
            this[field].blocks[blockIndex].model[index][SubConfiguration] = "";
          } else if (isIndex && !isBlockIndex) {
            this[field].model[index][SubConfiguration] = "";
          } else {
            this[field].model[SubConfiguration] = "";
          }

          this.resetSubSubConfiguration(field, "model", index, count, 0, blockIndex);
          this.resetSubSubConfiguration(field, "options", index, count, 0, blockIndex);
          break;

        case SubConfiguration:
          this.resetSubSubConfiguration(field, "model", index, count, 0, blockIndex);
          break;

        default:
          break;
      }

      // Reset only for the SubSubConfigs
      if (currentKey.includes(SubSubConfiguration)) {
          const start = +currentKey[currentKey.length - 1];
          this.resetSubSubConfiguration(field, "model", index, count, start, blockIndex);
          this.resetSubSubConfiguration(field, "options", index, count, start + 1, blockIndex);
      }
    },

    resetSubSubConfiguration(field, dataField, index, count, start = 0, blockIndex) {
      const value = dataField === "model" ? "" : [];
      for (let i = start; i < count; i++) {
        if (!isNaN(blockIndex)) {
          this[field].blocks[blockIndex][dataField][index][`${FIELD_KEYS.SubSubConfiguration}${i + 1}`] = value;
        } else if (!isNaN(index) && isNaN(blockIndex)) {
          this[field][dataField][index][`${FIELD_KEYS.SubSubConfiguration}${i + 1}`] = value;
        } else {
          this[field][dataField][`${FIELD_KEYS.SubSubConfiguration}${i + 1}`] = value;
        }
      }
    },

    getComponentType(field, key, index, blockIndex) {
      const result = this[field].blocks[blockIndex].components[index][key]
        ?? PAYLOAD_TO_COMPONENT_TYPES_MAP.Default;
      return result;
    },

    validateTriggerField($event, field, currentKey) {
      this[field].errors[currentKey] = $event.hasErrors;
    },
  }
}
